// 键盘事件处理混入
export default {
  data() {
    return {
      KeyHandler: null,
      keyMap: {},
    };
  },
  watch: {
    priceEditDialogVisible() {
      if (!this.priceEditDialogVisible) {
        // 创建键盘事件处理函数
        this.KeyHandler = this.createKeyHandler();
        // 使用capture阶段确保我们的监听器优先执行
        window.addEventListener("keydown", this.KeyHandler, true);
      }
    }
  },
  mounted() {
    // 进入页面时自动全屏
    // enterFullScreen();
    this.$http.cashdeskGetKeyMap().then(res => {
      console.log(res, 'res990');

      this.keyMap = res.result;

    })
    // 创建键盘事件处理函数
    this.KeyHandler = this.createKeyHandler();
    // 使用capture阶段确保我们的监听器优先执行
    window.addEventListener("keydown", this.KeyHandler, true);
    this.updateTimeVars();
    this.timeTimer = setInterval(this.updateTimeVars, 1000);
  },
  beforeDestroy() {
    // 移除监听器
    if (this.KeyHandler) {
      window.removeEventListener("keydown", this.KeyHandler, true);
    }
  },
  methods: {
    closeClick() {
      // 移除监听器
      if (this.KeyHandler) {
        window.removeEventListener("keydown", this.KeyHandler, true);
      }
    },
    openClick() {
      // 创建键盘事件处理函数
      this.KeyHandler = this.createKeyHandler();
      // 使用capture阶段确保我们的监听器优先执行
      window.addEventListener("keydown", this.KeyHandler, true);
    },
    getKeyMap(groupKey) {
      if (!groupKey) {
        return this.keyMap;
      }
      return this.keyMap[groupKey] || null;
    },

    // 检查按键是否匹配配置
    checkKeyMatch(event, keyConfig) {
      const { workKey, functionKey } = keyConfig;

      // 检查主键是否匹配
      if (event.key !== workKey) {
        return false;
      }

      // 如果没有功能键，检查是否没有按下修饰键
      if (!functionKey) {
        return !event.ctrlKey && !event.shiftKey && !event.altKey;
      }

      // 检查功能键组合
      switch (functionKey.toLowerCase()) {
        case 'ctrlkey':
          return event.ctrlKey && !event.shiftKey && !event.altKey;
        case 'shiftkey':
          return event.shiftKey && !event.ctrlKey && !event.altKey;
        case 'altkey':
          return event.altKey && !event.ctrlKey && !event.shiftKey;
        default:
          return false;
      }
    },

    // 根据keyMap处理动态快捷键
    handleDynamicShortcuts(event) {
      if (!this.keyMap || Object.keys(this.keyMap).length === 0) {
        return false;
      }

      delete this.keyMap['QRJZ'];
      delete this.keyMap['JB'];

      for (const [groupKey, config] of Object.entries(this.keyMap)) {
        if (this.checkKeyMatch(event, config)) {
          // 如果是SZXSY快捷键，不阻止默认行为，让输入框正常输入
          if (groupKey === 'SZXSY' || groupKey === 'XSYXZ' || groupKey === 'XGDJ' || groupKey === 'XGSL' || groupKey === 'SCSP') {
            return false;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          // 根据groupKey执行对应的功能
          this.executeFunctionByGroupKey(groupKey);
          return true;
        }
      }

      return false;
    },

    // 根据groupKey执行对应的功能
    async executeFunctionByGroupKey(groupKey) {

      console.log(groupKey, 'groupKey');
      switch (groupKey) {

        case 'SPLR': // 商品录入
          // 直接聚焦到商品选择输入框
          this.$nextTick(() => {
            if (this.$refs.productSearchInput) {
              // 获取实际的input元素
              const inputElement =
                this.$refs.productSearchInput.$el.querySelector("input");
              if (inputElement) {
                inputElement.focus();
                inputElement.select(); // 选中输入框中的内容
              }
            }
          });
          break;
        case 'XSYXZ': // 销售员选择
          if (this.$refs.salesPersonSelect) {
            this.$refs.salesPersonSelect[0].focus();
          }
          break;
        case 'HYLR': // 会员录入
          this.$nextTick(() => {
            if (this.$refs.memberCardInput) {
              this.$refs.memberCardInput[0].focus();
            }
          });
          break;
        case 'SPXZ': // 商品选择
          console.log("商品选择");
          this.enterCartSelectionMode();
          break;
        case 'XGKMM': // 修改密码
          this.openChangePasswordDialog();
          break;
        case 'GD': // 挂单
          this.onHoldOrder();
          break;
        case 'QD': // 取单
          this.onFetchOrder();
          break;
        case 'BK': //办卡
          this.actionData = {
            cate: 0,
            formData: [],
            storeId: this.storeId,
          };
          this.showStatus = true;
          break;
        case 'TH': // 退货
          // 清空购物车
          this.cartItems = [];
          this.updateTotal();
          //  退货
          console.log("退货！");
          this.openReturnDialog();
          break;
        case 'LSTH': // 临时退货
          console.log("临时退货！");
          this.openTempReturnDialog();
          break;
        case 'KCFB': // 库存分布
          console.log("库存分布查询！");
          this.openStockDistributionDialog();
          break;
        case 'JB': // 交班
          this.shiftDialogVisible = true;
          break;
        case 'FK': // 付款
          // 检查是否有商品有效期小于30天，拦截提示
          const res = await this.checkExpireDate()
          if (res) {
            return;
          }
          // 加载账簿列表
          this.queryCashdeskBook();
          if (!this.bookSelectDialogVisible) {
            // 是否有监管码
            this.checkRegulatoryCode()

            // this.openBookSelectDialog();
          }
          break;
        case 'TC': // 退出
          this.onExit();
          break;
        case 'SYFYXP': // 收银复印小票
          this.openSummaryDetailDialog();
          break;

        case 'TMWH': // 条码维护
          if (this.cartItems.length === 0) {
            this.$message.warning('请先加入商品');
            return;
          }
          this.openBarcodeMaintenanceDialog();
          break;
        case 'HYCZ': // 会员储值
          this.handleRechargeShortcut();
          break;
        case 'QKHYXX': // 清空会员卡信息
          this.clearMemberInfo();
          break;
        case 'QKGWC': // 清空购物车
          // 清空购物车
          this.cartItems = [];
          this.memberInfo.pharmacist = ''
          this.memberInfo.doctor = ''
          this.updateTotal();
          break;
        case 'CFSP': // 拆分商品
          this.splitItem();
          break;
        case 'ZYFS': // 中药副数
          this.openTCMDosageDialog();
          break;
        case 'JSQ': // 计算器
          this.openCalculatorDialog();
          break;
        case 'ZZLY': // 制作卤药
          this.openLuyaoMakeDialog();
          break;
        case 'CXFA': // 促销方案
          this.isAllPromotion = false;
          this.openPromotionSelectDialog();
          break;
        case 'KCYCXFA': // 促销方案
          this.isAllPromotion = false;
          this.openPromotionSelectDialogII();
          break;
        case 'DKQX': // 打开钱箱
          this.$printSocketApi.previewReport(
            '',
            '77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxSZXBvcnQgU2NyaXB0TGFuZ3VhZ2U9IkNTaGFycCIgUmVwb3J0SW5mby5DcmVhdGVkPSIxMC8xMS8yMDI1IDIwOjU2OjA1IiBSZXBvcnRJbmZvLk1vZGlmaWVkPSIxMC8xMS8yMDI1IDIwOjU5OjAyIiBSZXBvcnRJbmZvLkNyZWF0b3JWZXJzaW9uPSIyMDE3LjEuMTYuMCIgUHJpbnRTZXR0aW5ncy5TaG93RGlhbG9nPSJmYWxzZSI+DQogIDxEaWN0aW9uYXJ5Pg0KICAgIDxQYXJhbWV0ZXIgTmFtZT0ib3BtTmFtZSIgRGF0YVR5cGU9IlN5c3RlbS5TdHJpbmciLz4NCiAgICA8UGFyYW1ldGVyIE5hbWU9ImFkZHJlc3MiIERhdGFUeXBlPSJTeXN0ZW0uU3RyaW5nIi8+DQogICAgPFBhcmFtZXRlciBOYW1lPSJjb250YWN0IiBEYXRhVHlwZT0iU3lzdGVtLlN0cmluZyIvPg0KICAgIDxQYXJhbWV0ZXIgTmFtZT0icGhvbmUiIERhdGFUeXBlPSJTeXN0ZW0uU3RyaW5nIi8+DQogICAgPFBhcmFtZXRlciBOYW1lPSJ1bml0IiBEYXRhVHlwZT0iU3lzdGVtLlN0cmluZyIvPg0KICAgIDxQYXJhbWV0ZXIgTmFtZT0icHJpbnRDb3VudCIgRGF0YVR5cGU9IlN5c3RlbS5TdHJpbmciLz4NCiAgPC9EaWN0aW9uYXJ5Pg0KICA8UmVwb3J0UGFnZSBOYW1lPSJQYWdlMSIgUGFwZXJXaWR0aD0iNjAiIFBhcGVySGVpZ2h0PSIxIiBMZWZ0TWFyZ2luPSIwIiBUb3BNYXJnaW49IjAiIFJpZ2h0TWFyZ2luPSIwIiBCb3R0b21NYXJnaW49IjAiPg0KICAgIDxSZXBvcnRUaXRsZUJhbmQgTmFtZT0iUmVwb3J0VGl0bGUxIiBXaWR0aD0iMjI2LjgiIEhlaWdodD0iMy43OCI+DQogICAgICA8VGV4dE9iamVjdCBOYW1lPSJUZXh0MSIgTGVmdD0iNTYuNyIgV2lkdGg9Ijk0LjUiIEhlaWdodD0iMy43OCIvPg0KICAgIDwvUmVwb3J0VGl0bGVCYW5kPg0KICA8L1JlcG9ydFBhZ2U+DQo8L1JlcG9ydD4NCg==',
            "print",
            "",
            0, //打印次数
            ''
          );
          break;
        // default:
        //   console.log('未知的功能键:', groupKey);
      }
    },

    handleShortcutKey(key) {
      this.executeFunctionByGroupKey(key)
    },
    handleShortcutKeyShop(key) {
      if (key == 'ZYFS') {
        this.executeFunctionByGroupKey(key)
        return
      }
      this.executeCartFunctionByGroupKey(key)

    },
    createKeyHandler() {
      return (event) => {
        console.log("键盘事件触发:", event.key);

        // 如果账簿选择弹窗打开，且是F1-F12键，不在全局处理，让账簿弹窗自己处理
        if (this.bookSelectDialogVisible) {
          // 不处理F键，让账簿弹窗自己处理
          return;
        }
        if (this.payShow) {
          // 不处理F键
          return;
        }
        // 计算器打开，不处理快捷键
        if (this.calculatorDialogVisible) {
          return;
        }
        // 商品录入打开，不处理快捷键
        if (this.productSelectDialogVisible) {
          return
        }
        // 制作卤药打开，不处理快捷键
        if (this.luyaoMakeDialogVisible) {
          return
        }
        // 优先处理动态快捷键
        if (this.handleDynamicShortcuts(event)) {
          return;
        }

        // 检查是否有弹窗打开，如果有则禁用其他快捷键（除了ESC和F12）
        if (event.key === "\\") {
          event.preventDefault();
          event.stopPropagation();
          this.openPromotionSelectDialogII();
          return false;
        }
        // 禁用其他常用浏览器快捷键
        if (event.ctrlKey) {
          // 禁用 Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+A, Ctrl+Z, Ctrl+Y, Ctrl+F, Ctrl+P 等
          const disabledKeys = [
            "c",
            "v",
            "x",
            "a",
            "z",
            "y",
            "f",
            "p",
            "s",
            "n",
            "o",
            "w",
            "t",
          ];
          if (disabledKeys.includes(event.key.toLowerCase())) {
            return;
          }
        }

      };
    },
    // 处理购物车的键盘事件
    handleCartKeyDown(event) {
      console.log("购物车键盘事件触发:", event.key);

      // 优先处理动态快捷键
      if (this.handleCartDynamicShortcuts(event)) {
        return;
      }

      // 处理一些固定的导航键（不在动态配置中）
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
        event.stopPropagation();
        console.log("处理上下键选择");
        this.handleCartSelection(event.key);
        return;
      } else if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        console.log("处理回车键");
        this.editSelectedItemQuantity();
        return;
      }
    },

    // 处理购物车的动态快捷键
    handleCartDynamicShortcuts(event) {
      if (!this.keyMap || Object.keys(this.keyMap).length === 0) {
        return false;
      }

      for (const [groupKey, config] of Object.entries(this.keyMap)) {
        if (this.checkKeyMatch(event, config)) {
          event.preventDefault();
          event.stopPropagation();

          // 根据groupKey执行对应的购物车功能
          this.executeCartFunctionByGroupKey(groupKey);
          return true;
        }
      }

      return false;
    },

    // 根据groupKey执行购物车相关功能
    executeCartFunctionByGroupKey(groupKey) {
      console.log('购物车快捷键:', groupKey);

      switch (groupKey) {
        case 'SPXZ': // 商品选择/F4
          this.enterCartSelectionMode();
          break;
        case 'XGDJ': // 修改单价
          this.openPriceEditDialog();
          break;
        case 'XGSL': // 修改数量
          this.openQuantityEditDialog();
          break;
        case 'SCSP': // 删除商品
          this.removeSelectedItem();
          break;
        case 'SZXSY': // 设置销售员
          this.openSalesPersonSelectDialog();
          break;
        case 'DZJG': // 扫电子监管码
          const specialItems = this.cartItems.filter(
            (item) => item.bgiIsesupervise == 1
          );
          console.log(specialItems, 'specialItems');
          if (specialItems.length > 0 && this.scanCode == 1) {
            this.isDZJG = true
            // 显示监管码录入弹窗
            this.regulatoryCodeDialogVisible = true;
          } else {
            this.$message.error('此商品非监管商品')
          }
          break;
        // case 'KCYCXFA': // 促销方案
        //   this.openPromotionSelectDialogII();
        //   break;
        default:
          console.log('未知的购物车功能键:', groupKey);
      }
    },
    // 处理购物车选择
    handleCartSelection(key) {
      if (this.cartItems.length === 0) {
        console.log("购物车为空，不处理选择");
        return;
      }

      // 如果当前没有选中项，默认选中第一个
      if (this.selectedItemIndex === -1) {
        this.selectedItemIndex = 0;
        console.log("没有选中项，默认选中第一个:", this.selectedItemIndex);
      } else {
        // 根据按键更新选中索引
        if (key === "ArrowUp") {
          // 向上选择
          if (this.selectedItemIndex > 0) {
            this.selectedItemIndex--;
          } else {
            this.selectedItemIndex = this.cartItems.length - 1;
          }
          console.log("向上选择，新索引:", this.selectedItemIndex);
        } else if (key === "ArrowDown") {
          // 向下选择
          if (this.selectedItemIndex < this.cartItems.length - 1) {
            this.selectedItemIndex++;
          } else {
            this.selectedItemIndex = 0;
          }
          console.log("向下选择，新索引:", this.selectedItemIndex);
        }
      }

      // 重置列索引为销售员列
      this.selectedColumnIndex = 0;

      // 同步更新商品选择区域的信息
      this.syncSelectedItemToProductArea();

      // 滚动到选中项
      this.$nextTick(() => {
        this.scrollToSelectedCartItem();
        // 确保表格保持焦点
        this.focusCartTable();
      });
    },
    // 同步选中商品到商品选择区域
    syncSelectedItemToProductArea() {
      if (
        this.selectedItemIndex >= 0 &&
        this.selectedItemIndex < this.cartItems.length
      ) {
        const item = this.cartItems[this.selectedItemIndex];
        this.selectedProduct = { ...item };
        // 不同步购物车中商品的数量到数量输入框，保持数量输入框为1
        // this.quantity = item.quantity || 1;
      }
    },
    // 编辑选中商品的数量
    editSelectedItemQuantity() {
      if (
        this.selectedItemIndex >= 0 &&
        this.selectedItemIndex < this.cartItems.length
      ) {
        // 设置列索引为数量列
        this.selectedColumnIndex = 2;
        // 聚焦到购物车中选中商品的数量输入框
        this.focusCartTable();
      }
    },
    // 进入购物车商品选择模式
    enterCartSelectionMode() {
      // 检查购物车是否有商品
      if (this.cartItems.length === 0) {
        this.$message.warning("购物车中没有商品");
        return;
      }
      // 如果没有选中的商品，默认选中第一个
      if (this.selectedItemIndex === -1) {
        this.selectedItemIndex = 0;
        this.syncSelectedItemToProductArea();
      }

      // 重置列索引为销售员列
      this.selectedColumnIndex = 0;

      // 聚焦到购物车表格
      this.focusCartTable();

      // 滚动到选中的商品
      this.$nextTick(() => {
        this.scrollToSelectedCartItem();
      });
    },
    // 商品选择弹窗打开事件
    onProductDialogOpen() {

      this.selectedProductIndex2 = -1; // 重置选中状态
      this.$nextTick(() => {
        // 聚焦到表格
        if (this.$refs.productTable) {
          this.$refs.productTable.$el.focus();

        }

        // 如果有商品列表，默认选中第一个并滚动到位置
        if (this.productSelectList.length > 0) {
          this.selectedProductIndex2 = 0;
          this.scrollToSelectedProduct();

          // 设置Element UI的当前行高亮
          if (this.$refs.productTable) {
            this.$refs.productTable.setCurrentRow(this.productSelectList[0]);
          }
        }
      });
      setTimeout(() => {
        if (this.productSelectList && this.productSelectList.length > 0) {
          // 聚焦到第一行的数量输入框
          this.focusQuantityInputByIndex(0);
        }
        this.$refs.productTable.setCurrentRow(this.productSelectList[0]);

      }, 100);
    },
    // 滚动到选中的购物车商品
    scrollToSelectedCartItem() {
      const tableBody = this.$el.querySelector(
        ".cart-table .el-table__body-wrapper"
      );
      if (tableBody && this.selectedItemIndex >= 0) {
        const rows = tableBody.querySelectorAll(".el-table__row");
        if (rows[this.selectedItemIndex]) {
          rows[this.selectedItemIndex].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
      }
    },
    // 删除选中的商品
    removeSelectedItem() {
      console.log("删除选中商品，当前索引:", this.selectedItemIndex);
      if (this.selectedItemIndex === -1) {
        this.$message.warning("请先选择要删除的商品");
        return;
      }

      const delIndex = this.selectedItemIndex;
      console.log("删除索引为", delIndex, "的商品");
      if (this.cartItems[this.selectedItemIndex].bgiIsesupervise == 1) {
        const specialItems = this.cartItems.filter(
          (item) => item.bgiIsesupervise == 1
        );
        let totalNum = 0
        specialItems.forEach((item) => {
          totalNum += item.quantity
        });
        if (this.esuList&&this.esuList.length > 0 && this.esuList.length >= totalNum) {
          return this.$message.warning("请先删除电子监管码")
        }
      }
      // 确认删除
      this.$confirm("确认删除选中的商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.resetPromotion(-1, true); // forceResetToOriginal = true
          this.resetSingleItemToOriginal(this.cartItems[this.selectedItemIndex]);
          this.removeItem(delIndex);

          // 删除后如果购物车还有商品，默认选中上一个（或新的最后一个）
          if (this.cartItems.length > 0) {
            let newIndex = delIndex - 1;
            if (newIndex < 0) newIndex = 0;
            if (newIndex >= this.cartItems.length)
              newIndex = this.cartItems.length - 1;
            this.selectedItemIndex = newIndex;
            console.log("删除后选中新索引:", this.selectedItemIndex);
            this.syncSelectedItemToProductArea();

            // 滚动到选中项并保持焦点
            this.$nextTick(() => {
              this.scrollToSelectedCartItem();
              this.focusCartTable(); // 确保删除后表格仍然有焦点
            });
          } else {
            this.selectedItemIndex = -1;
            this.quantityChange = '';
            this.selectedProduct = {};
            console.log("购物车已清空");
          }
        })
        .catch(() => {
          // 取消删除，恢复焦点
          this.$nextTick(() => {
            this.focusCartTable();
          });
        });
    },
    // 清空会员卡信息的方法
    clearMemberInfo() {
      // 检查购物车中是否有含麻或专管商品
      const specialItems = this.cartItems.filter(
        (item) =>
          item.bgiType &&
          (item.bgiType.includes("含麻") || item.bgiType.includes("专管"))
      );

      if (specialItems.length > 0) {
        this.$message.warning(
          "购物车中包含含麻或专管商品，请先删除这些商品后再清空会员卡信息"
        );
        return false;
      }
      this.resetPromotionToOriginal(); // 重置到最初始状态
      // 方案列表清空
      this.selectedPromotions = [];

      // 清空会员卡信息
      // this.memberCardNo = '';
      this.memberInfo.customerName = "";
      this.memberInfo.customerPhoneNumber = "";
      this.memberInfo.customerIdCard = "";
      this.memberInfo.cardType = "";
      this.memberInfo.points = "";
      this.memberInfo.registerStore = "";
      this.memberInfo.level = "";
      this.memberInfo.storedBalance = "";
      this.memberInfo.memId = "";
      this.isMemberFromDropdown = false; // 重置会员信息来源标记，允许重新输入
      this.cartItems.forEach(item => {
        delete item.spPrice;
        delete item.spMemberPrice;
        delete item.usedNum;

      });
      // 实时参与活动方案
      this.getRealTimePromotions();
      this.recalculateCartPrices();
      return true;
    },
    // 检查是否有监管码
    checkRegulatoryCode() {
      console.log(111111, '检查是否有监管码');
      const specialItems = this.cartItems.filter(
        (item) => item.bgiIsesupervise == 1
      );
      let totalNum = 0
      specialItems.forEach((item) => {
        totalNum += item.quantity
      });
      if (specialItems.length > 0 && this.scanCode == 1 &&this.esuList&& this.esuList.length != totalNum) {
        // 显示监管码录入弹窗
        this.regulatoryCodeDialogVisible = true;
        return false; // 阻止继续执行收款流程
      }

      // 检查是否有整单的优惠方案
      this.sellPlanCheckOrderPlan();
    },
    // 处理监管码确认事件
    async onRegulatoryCodeConfirm(regulatoryData) {
      console.log('📋 监管码录入确认:', regulatoryData);
      this.esuList = regulatoryData.regulatoryCodes;
      if (this.isDZJG) {//判断是否是付款的时候强制扫码 false：是 true：否
        this.isDZJG = false
        return
      }
      // 监管码录入完成后，继续执行收款流程
      this.continueCheckoutProcess();

    },

    // 处理监管码关闭事件
    onRegulatoryCodeClose() {
      console.log('📋 监管码弹窗已关闭');
      // 用户取消了监管码录入，不继续收款流程
      // this.esuList = [];
    },


    // 继续执行收款流程
    continueCheckoutProcess() {
      // 监管码录入完成后，继续执行原来的收款流程
      this.sellPlanCheckOrderPlan();
    },

    // 检查是否有整单的优惠方案
    async sellPlanCheckOrderPlan() {
      try {
        // 构建通用的商品信息列表
        const bgmInfoList = this.cartItems.map((item) => ({
          bgmId: item.bgmId,
          num: item.quantity,
          recPrice: item.amount,
          sellPrice: item.price * item.quantity,
          mzConType: item.mzConType,
          mzGiftType: item.mzGiftType,
          planType: item.planType,
        }));

        // 构建通用的请求参数
        const commonParams = {
          bgmInfoList,
          curDate: this.curDate,
          curTime: this.curTime,
          day: this.day,
          memId: this.memberInfo.memId ? this.memberInfo.memId : "",
          storeId: this.storeId,
          week: this.week,
        };

        // 并行调用两个接口
        const [yhqRes, planRes] = await Promise.all([
          // 检查可用优惠券
          this.$http.checkOrderYhq(commonParams),
          // 检查整单优惠方案
          this.$http.sellPlanCheckOrderPlan({
            ...commonParams,
            isMem: this.memberInfo.memId ? 1 : 0,
          }),
        ]);

        console.log(yhqRes, "yhqRes");
        console.log(planRes, "planRes");

        // 判断接口调用是否成功
        const yhqSuccess = yhqRes && yhqRes.status === 200 && yhqRes.result;
        const planSuccess = planRes && planRes.status === 200 && planRes.result;
        let yhqList = [];
        if (yhqRes.result.length > 0) {
          yhqList = yhqRes.result.map((item) => {
            return {
              ...item.planDetail,
              yhqMem: {
                ...item.yhqMem,
              },
            };
          });
        }
        // 获取结果数据
        const planList = planSuccess ? planRes.result : [];
        console.log(yhqList, "yhqList");
        console.log(planList, "planList");

        // 合并判断逻辑
        if (yhqSuccess || planSuccess) {
          // 如果只有优惠券没有整单优惠方案
          if (yhqList.length === 0 && planList.length === 0) {
            this.isAllPromotion = false;
            this.openBookSelectDialog();
          }
          // 如果有整单优惠方案（无论是否有优惠券）
          else if (planList.length > 0 || yhqList.length > 0) {
            this.isAllPromotion = true;
            // 有整单优惠是否参与
            this.$confirm("有整单优惠是否参与?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "info",
            })
              .then(() => {
                console.log(planList, "planList");
                console.log(planList, "yhqList");
                this.promotionSelectList = [...planList, ...yhqList];
                console.log(
                  this.promotionSelectList,
                  "this.promotionSelectList"
                );

                this.promotionSelectDialogVisible = true;
                this.giftList = [];
                this.giftYhqList = [];
                this.allGiftList = [];
                this.allGiftYhqList = [];

                console.log(this.cartItems, "this.cartItems3333");
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "不参与整单优惠!",
                });
                this.openBookSelectDialog();
              });
          }
        } else {
          // 接口调用失败的处理
          const errorMsg = planRes?.message || yhqRes?.message || "未知错误";
          // this.$message.error("检查整单优惠方案失败:" + errorMsg);
        }
      } catch (error) {
        // this.$message.warning(error);
      }
    },
    onShiftDialogOpened() { },
    onShiftDialogClose() {
      this.shiftDialogVisible = false;
    },
    onShiftConfirm(shiftData) {
      this.onShiftChange(shiftData);
    },
    onShiftChange(shiftData) {
      // 交班前确认
      this.$confirm(
        "确认要交班吗？交班后将清空所有挂单信息并退出到登录页。",
        "交班确认",
        {
          confirmButtonText: "确认交班",
          cancelButtonText: "取消",
          type: "warning",
          closeOnPressEscape: true,
          closeOnClickModal: false,
          distinguishCancelAndClose: true,
          center: true,
          showCancelButton: false,
        }
      )
        .then(() => {
          // 用户点击确认
          if (this.cartItems.length > 0) {
            // 如果购物车不为空，再次确认
            return this.$confirm(
              "购物车中还有未结算的商品，确认要交班吗？",
              "二次确认",
              {
                confirmButtonText: "确认交班",
                cancelButtonText: "取消",
                type: "warning",
                closeOnPressEscape: true,
                closeOnClickModal: false,
                distinguishCancelAndClose: true,
                center: true,
              }
            );
          }

          return Promise.resolve();
        })
        .then(async () => {
          const res = await this.$http.submitBc({ ids: [shiftData.bcInfo.id] })
          if (res.status === 200) {
            this.printJBD(res.result)
          } else {
            this.$message.error("交班失败:" + res.message);
          }
        })
        .catch(() => {
          // 用户取消交班
          this.$message.info("已取消交班");
        });
    },
    async printJBD(val) {
      const res = await this.$http.printDataretailBcPrint({ id:val })
      if (res.status === 200) {
        this.$printSocketApi.previewReport(
          res.result,
          this.jbPrint,
          "print",
          "",
          0, //打印次数
          val
        );
        this.$message.success("交班成功，正在退出到登录页...");
        setTimeout(() => {
          this.holdOrderList = [];
          this.selectedHoldOrderIndex = -1;
          setTimeout(() => {
            // 跳转到登录页，假设路由名为login
            this.$router.replace({ name: "login" });
          }, 800);
        }, 1000);
      } else {
        this.$message.error("打印失败:" + res.message)
      }
    },
    updateTimeVars() {
      const now = new Date();
      this.day = now.getDate();
      // 获取当天0点的时间戳
      this.curDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      ).getTime();
      // 获取当前时间的总秒数（从00:00:00开始计算）
      const getCurrentTimeInSeconds = () => {
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();

        return hours * 3600 + minutes * 60 + seconds;
      };
      this.curTime = getCurrentTimeInSeconds();
      // 获取当前星期几（1-7，1为周一，7为周日）
      this.week = now.getDay() === 0 ? 7 : now.getDay();

      // 更新当前时间显示
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const date = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const weekDays = ["日", "一", "二", "三", "四", "五", "六"];
      const weekDay = weekDays[now.getDay()];

      this.currentTime = `${year}-${month}-${date} ${hours}:${minutes}:${seconds} 星期${weekDay}`;
    },
    enterFullScreen() {
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        // Firefox
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        // Chrome, Safari, Opera
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        // IE/Edge
        element.msRequestFullscreen();
      }
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari, Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    },
    onExit() {
      // 退出全屏
      // exitFullScreen();

      this.$emit("setIsPenetrate", false);
      this.$message.info("已退出收银台页面");

      // this.$confirm('确认要退出收银台吗？', '退出确认', {
      //   confirmButtonText: '确认退出',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      //   closeOnPressEscape: true,
      //   closeOnClickModal: false,
      //   distinguishCancelAndClose: true,
      //   center: true
      // }).then(() => {
      //   // 用户点击确认
      //   if (this.cartItems.length > 0) {
      //     // 如果购物车不为空，再次确认
      //     return this.$confirm('购物车中还有未结算的商品，确认要退出吗？', '二次确认', {
      //       confirmButtonText: '确认退出',
      //       cancelButtonText: '取消',
      //       type: 'warning',
      //       closeOnPressEscape: true,
      //       closeOnClickModal: false,
      //       distinguishCancelAndClose: true,
      //       center: true
      //     });
      //   }
      //   return Promise.resolve();
      // }).then(() => {
      //   this.$emit('setIsPenetrate', false);
      //   this.$message.success('已退出收银台页面');
      // }).catch(() => {
      //   // 用户取消退出
      //   this.$message.info('已取消退出');
      // });
    },

    // ------------------促销方案---------------
    handlePromotionSelectionChange(selectedRows) {
      // 检查是否取消了满赠促销方案
      const previousMzPromotions = this.selectedPromotions.filter(
        (plan) => plan.sellType === 32
      );
      const currentMzPromotions = selectedRows.filter(
        (plan) => plan.sellType === 32
      );
      // 如果满赠促销方案减少了，清除相关赠品
      if (previousMzPromotions.length > currentMzPromotions.length) {
        if (!this.isAllPromotion) {
          // this.resetPromotion();
          this.removeGiftItemsFromCart(this.usedPromotions); // 传入空数组，清除所有赠品
        }
      }
      this.selectedPromotions = selectedRows;
      // 动态更新赠品列表
      this.updateGiftList();
    },
    // 处理全选事件
    handleSelectAll(selection) {
      // 获取当前可见的促销方案列表
      const visiblePromotions = this.filterPromotionSelectList();
      // 如果是全选操作（selection包含所有行）
      if (selection.length === visiblePromotions.length) {
        // 清除当前选择
        this.$refs.promotionTable.clearSelection();
        // 只选择可选的行
        const selectablePromotions = [];
        for (const promotion of visiblePromotions) {
          if (this.promotionSelectable(promotion)) {
            selectablePromotions.push(promotion);
            this.$refs.promotionTable.toggleRowSelection(promotion, true);
          }
        }
        if (selectablePromotions.length === 0) {
          this.$message.warning(
            "没有可选择的促销方案，请检查商品冲突或条件是否满足"
          );
        } else if (selectablePromotions.length < visiblePromotions.length) {
          this.$message.info(
            `已选择 ${selectablePromotions.length} 个可用方案，${visiblePromotions.length - selectablePromotions.length
            } 个方案因冲突被跳过`
          );
        }
      } else {
        // 如果是取消全选操作
        console.log("执行取消全选操作");
        this.resetPromotion();
        this.updateTotal();
      }
    },
    onPromotionSelect(row) {
      if (!this.isAllPromotion) {
        // 重置促销方案
        this.resetPromotion();
      }
      // 检查当前行是否可选
      if (!this.promotionSelectable(row)) {
        this.$message.warning("该促销方案与已选方案冲突，无法选择");
        return;
      }
      // 切换当前行的选择状态
      this.$refs.promotionTable.toggleRowSelection(row);
    },
    // 处理促销方案表格的键盘事件
    handleKeyDown(event) {
      switch (event.key) {
        case "ArrowUp":
          event.preventDefault();
          if (this.currentFocusArea === "promotion") {
            const promotionList = this.filterPromotionSelectList();
            if (promotionList && promotionList.length > 0) {
              if (this.currentHighlightRowIndex === 0) {
                // 如果在第一行，向上导航到确认按钮
                this.currentFocusArea = "confirm";
                this.focusConfirmButton();
              } else {
                this.currentHighlightRowIndex = Math.max(
                  0,
                  this.currentHighlightRowIndex - 1
                );
                this.setCurrentRow();
              }
            }
          } else if (this.currentFocusArea === "confirm") {
            // 从确认按钮向上导航到促销表格的最后一行
            const promotionList = this.filterPromotionSelectList();
            if (promotionList && promotionList.length > 0) {
              this.currentFocusArea = "promotion";
              this.currentHighlightRowIndex = promotionList.length - 1;
              this.focusPromotionTable();
            }
          }
          break;
        case "ArrowDown":
          event.preventDefault();
          if (this.currentFocusArea === "promotion") {
            const promotionList = this.filterPromotionSelectList();
            if (promotionList && promotionList.length > 0) {
              if (this.currentHighlightRowIndex === promotionList.length - 1) {
                // 如果在最后一行，向下导航到确认按钮
                this.currentFocusArea = "confirm";
                this.focusConfirmButton();
              } else {
                this.currentHighlightRowIndex = Math.min(
                  promotionList.length - 1,
                  this.currentHighlightRowIndex + 1
                );
                this.setCurrentRow();
              }
            }
          } else if (this.currentFocusArea === "confirm") {
            // 从确认按钮向下导航到促销表格的第一行
            const promotionList = this.filterPromotionSelectList();
            if (promotionList && promotionList.length > 0) {
              this.currentFocusArea = "promotion";
              this.currentHighlightRowIndex = 0;
              this.focusPromotionTable();
            }
          }
          break;
        case "ArrowRight":
          event.preventDefault();
          this.switchToNextFocusArea();
          break;
        case "ArrowLeft":
          event.preventDefault();
          this.switchToPrevFocusArea();
          break;
        case "Enter":
          event.preventDefault();
          if (this.currentFocusArea === "promotion") {
            const promotionList = this.filterPromotionSelectList();
            if (promotionList && promotionList.length > 0) {
              const currentRow = promotionList[this.currentHighlightRowIndex];
              if (currentRow) {
                this.onPromotionSelect(currentRow);
              }
            }
          } else if (this.currentFocusArea === "confirm") {
            // 在确认按钮上按 Enter，执行确认操作
            if (!this.isAllPromotion) {
              this.confirmPromotionSelection();
            } else {
              this.confirmPromotionSelectionIII();
            }
          }
          break;
        case "Escape":
          event.preventDefault();
          this.promotionSelectDialogVisible = false;
          break;
      }
    },
    // 设置当前高亮行
    setCurrentRow() {
      const promotionList = this.filterPromotionSelectList();
      if (
        promotionList &&
        promotionList.length > 0 &&
        this.$refs.promotionTable
      ) {
        const currentRow = promotionList[this.currentHighlightRowIndex];
        if (currentRow) {
          this.$refs.promotionTable.setCurrentRow(currentRow);
        }
      }
    },
    // 切换到下一个聚焦区域
    switchToNextFocusArea() {
      const hasGiftSelection =
        this.selectedPromotions.some((plan) => plan.mzGiftType === 1) &&
        this.selectedPromotions.some((plan) => plan.mzGiftNumType === 1) &&
        this.singleSelectGiftList.length > 0;
      const hasCouponSelection =
        this.selectedPromotions.some((plan) => plan.mzGiftType === 2) &&
        this.selectedPromotions.some((plan) => plan.mzGiftNumType === 1) &&
        this.singleSelectCouponList.length > 0;

      if (this.currentFocusArea === "promotion") {
        if (hasGiftSelection) {
          this.currentFocusArea = "gift";
          this.focusGiftTable();
        } else if (hasCouponSelection) {
          this.currentFocusArea = "coupon";
          this.focusCouponTable();
        } else {
          this.currentFocusArea = "confirm";
          this.focusConfirmButton();
        }
      } else if (this.currentFocusArea === "gift") {
        if (hasCouponSelection) {
          this.currentFocusArea = "coupon";
          this.focusCouponTable();
        } else {
          this.currentFocusArea = "confirm";
          this.focusConfirmButton();
        }
      } else if (this.currentFocusArea === "coupon") {
        this.currentFocusArea = "confirm";
        this.focusConfirmButton();
      } else if (this.currentFocusArea === "confirm") {
        this.currentFocusArea = "promotion";
        this.focusPromotionTable();
      }
    },
    // 切换到上一个聚焦区域
    switchToPrevFocusArea() {
      const hasGiftSelection =
        this.selectedPromotions.some((plan) => plan.mzGiftType === 1) &&
        this.selectedPromotions.some((plan) => plan.mzGiftNumType === 1) &&
        this.singleSelectGiftList.length > 0;
      const hasCouponSelection =
        this.selectedPromotions.some((plan) => plan.mzGiftType === 2) &&
        this.selectedPromotions.some((plan) => plan.mzGiftNumType === 1) &&
        this.singleSelectCouponList.length > 0;

      if (this.currentFocusArea === "confirm") {
        if (hasCouponSelection) {
          this.currentFocusArea = "coupon";
          this.focusCouponTable();
        } else if (hasGiftSelection) {
          this.currentFocusArea = "gift";
          this.focusGiftTable();
        } else {
          this.currentFocusArea = "promotion";
          this.focusPromotionTable();
        }
      } else if (this.currentFocusArea === "coupon") {
        if (hasGiftSelection) {
          this.currentFocusArea = "gift";
          this.focusGiftTable();
        } else {
          this.currentFocusArea = "promotion";
          this.focusPromotionTable();
        }
      } else if (this.currentFocusArea === "gift") {
        this.currentFocusArea = "promotion";
        this.focusPromotionTable();
      } else if (this.currentFocusArea === "promotion") {
        this.currentFocusArea = "confirm";
        this.focusConfirmButton();
      }
    },
    // 聚焦到促销方案表格
    focusPromotionTable() {
      this.$nextTick(() => {
        if (this.$refs.promotionTable && this.$refs.promotionTable.$el) {
          this.$refs.promotionTable.$el.focus();
          this.setCurrentRow();
          console.log("聚焦到促销方案表格");
        }
      });
    },
    // 聚焦到赠品表格
    focusGiftTable() {
      this.$nextTick(() => {
        if (this.$refs.singleGiftTable && this.$refs.singleGiftTable.$el) {
          this.$refs.singleGiftTable.$el.focus();
          console.log("聚焦到赠品选择表格");
        }
      });
    },
    // 聚焦到优惠券表格
    focusCouponTable() {
      this.$nextTick(() => {
        if (this.$refs.singleCouponTable && this.$refs.singleCouponTable.$el) {
          this.$refs.singleCouponTable.$el.focus();
          console.log("聚焦到优惠券选择表格");
        }
      });
    },
    // 聚焦到确认按钮
    focusConfirmButton() {
      this.$nextTick(() => {
        if (this.$refs.confirmButton && this.$refs.confirmButton.$el) {
          this.$refs.confirmButton.$el.focus();
          console.log("聚焦到确认选择按钮");
        }
      });
    },
    // 处理确认按钮的键盘事件
    handleConfirmButtonKeyDown(event) {
      switch (event.key) {
        case "ArrowUp":
          event.preventDefault();
          // 从确认按钮向上导航到促销表格的最后一行
          const promotionList = this.filterPromotionSelectList();
          if (promotionList && promotionList.length > 0) {
            this.currentFocusArea = "promotion";
            this.currentHighlightRowIndex = promotionList.length - 1;
            this.focusPromotionTable();
          }
          break;
        case "ArrowDown":
          event.preventDefault();
          // 从确认按钮向下导航到促销表格的第一行
          const promotionListDown = this.filterPromotionSelectList();
          if (promotionListDown && promotionListDown.length > 0) {
            this.currentFocusArea = "promotion";
            this.currentHighlightRowIndex = 0;
            this.focusPromotionTable();
          }
          break;
        case "Enter":
          event.preventDefault();
          // 执行确认操作
          if (!this.isAllPromotion) {
            this.confirmPromotionSelection();
          } else {
            this.confirmPromotionSelectionIII();
          }
          break;
        case "Escape":
          event.preventDefault();
          this.promotionSelectDialogVisible = false;
          break;
      }
    },
    // 处理赠品表格的键盘事件
    handleGiftKeyDown(event) {
      switch (event.key) {
        case "ArrowUp":
          event.preventDefault();
          this.navigateGiftSelection(-1);
          break;
        case "ArrowDown":
          event.preventDefault();
          this.navigateGiftSelection(1);
          break;
        case "ArrowRight":
          event.preventDefault();
          this.switchToNextFocusArea();
          break;
        case "ArrowLeft":
          event.preventDefault();
          this.switchToPrevFocusArea();
          break;
        case "Enter":
          event.preventDefault();
          this.selectCurrentGift();
          break;
        case "Escape":
          event.preventDefault();
          this.promotionSelectDialogVisible = false;
          break;
      }
    },
    // 处理优惠券表格的键盘事件
    handleCouponKeyDown(event) {
      switch (event.key) {
        case "ArrowUp":
          event.preventDefault();
          this.navigateCouponSelection(-1);
          break;
        case "ArrowDown":
          event.preventDefault();
          this.navigateCouponSelection(1);
          break;
        case "ArrowRight":
          event.preventDefault();
          this.switchToNextFocusArea();
          break;
        case "ArrowLeft":
          event.preventDefault();
          this.switchToPrevFocusArea();
          break;
        case "Enter":
          event.preventDefault();
          this.selectCurrentCoupon();
          break;
        case "Escape":
          event.preventDefault();
          this.promotionSelectDialogVisible = false;
          break;
      }
    },
    // 导航赠品选择
    navigateGiftSelection(direction) {
      const giftList = this.singleSelectGiftList;
      if (!giftList || giftList.length === 0) return;

      const currentIndex = giftList.findIndex(
        (gift) => gift.bgmId === this.selectedSingleGift
      );
      let newIndex = currentIndex + direction;

      if (newIndex < 0) newIndex = giftList.length - 1;
      if (newIndex >= giftList.length) newIndex = 0;

      const newGift = giftList[newIndex];
      if (newGift && this.$refs.singleGiftTable) {
        this.$refs.singleGiftTable.setCurrentRow(newGift);
      }
    },
    // 导航优惠券选择
    navigateCouponSelection(direction) {
      const couponList = this.singleSelectCouponList;
      if (!couponList || couponList.length === 0) return;

      const currentIndex = couponList.findIndex(
        (coupon) => coupon.yhqId === this.selectedSingleCoupon
      );
      let newIndex = currentIndex + direction;

      if (newIndex < 0) newIndex = couponList.length - 1;
      if (newIndex >= couponList.length) newIndex = 0;

      const newCoupon = couponList[newIndex];
      if (newCoupon && this.$refs.singleCouponTable) {
        this.$refs.singleCouponTable.setCurrentRow(newCoupon);
      }
    },
    // 选择当前赠品
    selectCurrentGift() {
      const giftList = this.singleSelectGiftList;
      if (!giftList || giftList.length === 0) return;

      const currentRow = this.$refs.singleGiftTable
        ? this.$refs.singleGiftTable.store.states.currentRow
        : null;
      if (currentRow) {
        this.selectedSingleGift = currentRow.bgmId;
        this.onSingleGiftChange(currentRow);
      }
    },
    // 选择当前优惠券
    selectCurrentCoupon() {
      const couponList = this.singleSelectCouponList;
      if (!couponList || couponList.length === 0) return;

      const currentRow = this.$refs.singleCouponTable
        ? this.$refs.singleCouponTable.store.states.currentRow
        : null;
      if (currentRow) {
        this.selectedSingleCoupon = currentRow.yhqId;
        this.onSingleCouponChange(currentRow);
      }
    },
    // 动态更新赠品列表
    updateGiftList() {
      console.log("动态更新赠品列表");
      // 清空当前赠品列表
      this.giftList = [];
      this.allGiftList = [];
      this.giftYhqList = [];
      this.allGiftYhqList = [];
      this.mzGiftTypeNum = 0;
      this.mzGiftNum = 0;

      // 重置单选赠品状态
      this.selectedSingleGift = null;
      this._needAutoSelectGift = false;

      // 获取当前选中的满赠促销方案
      const selectedMzPromotions = this.selectedPromotions.filter(
        (plan) => plan.planType === 1
      );

      if (selectedMzPromotions.length === 0) {
        console.log("没有选中的满赠促销方案");
        return;
      }
      // 遍历选中的满赠促销方案，重新构建赠品列表
      selectedMzPromotions.forEach((plan) => {
        // mzConType 	满赠-促销类型（1：按金额、2：按商品、3：按类型）
        if (plan.mzGiftType == 1) {
          // 赠品类型
          if (plan.giftBgmList && Array.isArray(plan.giftBgmList)) {
            plan.giftBgmList.forEach((gift) => {
              // 检查是否已存在相同的赠品（避免重复）
              const existingGift = this.giftList.find(
                (item) =>
                  item.bgmId === gift.bgmId && item.planId === plan.planId
              );

              console.log(plan, "existingGift77");
              if (!existingGift) {
                const giftItem = {
                  ...gift,
                  planId: plan.planId,
                  planName: plan.planName,
                  stageDesc: `满${plan.mzConBgmNum || 0}件赠送${plan.mzGiftNum || 0
                    }件`,
                  giftNum: gift.giftNum || 0,
                  retailPrice: gift.retailPrice || 0,
                };

                this.giftList.push(giftItem);
                // 同时添加到 allGiftList（作为备用）
                this.allGiftList.push({ ...giftItem });
                console.log("添加赠品:", gift.bgmName, "方案:", plan.planName);
              }
            });
          }
        } else if (plan.mzGiftType == 2) {
          // 优惠券类型
          if (plan.giftYhqList && Array.isArray(plan.giftYhqList)) {
            plan.giftYhqList.forEach((gift) => {
              // 检查是否已存在相同的优惠券（避免重复）
              const existingCoupon = this.giftYhqList.find(
                (item) =>
                  item.yhqId === gift.yhqId && item.planId === plan.planId
              );
              if (!existingCoupon) {
                const couponItem = {
                  ...gift,
                  planId: plan.planId,
                  planName: plan.planName,
                  yhqId: gift.yhqId,
                  yhqName: gift.yhqName,
                  yhqDesc: gift.yhqDesc,
                  limitDay: gift.limitDay,
                  remark: gift.remark,
                  inputNum: 0,
                };
                console.log(couponItem, "couponItem");

                this.giftYhqList.push(couponItem);

                console.log(
                  "添加优惠券:",
                  gift.yhqName,
                  "方案:",
                  plan.planName
                );
              }
            });
          }
        }
      });

      console.log(
        "赠品列表更新完成，赠品数量:",
        this.giftList.length,
        "优惠券数量:",
        this.giftYhqList.length
      );
    },
    // 重新/变化数量，先还原方案，特价商品除外
    resetPromotion(specificItemIndex = -1, forceResetToOriginal = false, showMessage = true) {
      if (!this.isAllPromotion) {
        this.yhqGift = [];
        // 清除购物车中的赠品（满赠促销产生的商品）
        // this.removeGiftItemsFromCart(this.usedPromotions); // 传入空数组，清除所有赠品
      }
      this.mergeSameBatchItems();
      // 如果指定了特定商品索引，只重置该商品
      if (specificItemIndex >= 0 && specificItemIndex < this.cartItems.length) {
        const cartItem = this.cartItems[specificItemIndex];
        console.log("重置促销方案到原始单价", cartItem);
        // 如果是特价商品则重置为特价
        if (cartItem.isSpecialPrice || cartItem.spMemberPrice || cartItem.spPrice) {
          this.resetSpecialPriceItem(cartItem);
          return;
        }
        this.resetSingleItem(cartItem, forceResetToOriginal);

      } else {
        // 否则重置所有商品（除了特价商品）
        // 检查是否有任何需要重置的打折商品
        const regularDiscountedItems = this.cartItems.filter(
          (item) =>
            (item.isDiscounted || item.discountInfo || item.isMergedItem) &&
            !item.isSpecialPrice &&
            !item.isGift
        );
        if (showMessage) {
          if (regularDiscountedItems.length > 0) {
            if (forceResetToOriginal) {
              this.$message.info(
                "已清除所有促销方案，商品恢复原始单价，特价商品不受影响"
              );
            } else {
              this.$message.info(
                "所有常规促销商品的状态已重置，特价商品不受影响"
              );
            }
          }
        } else {

        }

        this.cartItems.forEach((cartItem) => {
          // 特价商品和赠品跳过
          if (cartItem.isSpecialPrice || cartItem.isGift) {
            if (cartItem.isSpecialPrice) {
              // 特价商品重置为特价，保持特价优惠
              this.resetSpecialPriceItem(cartItem);
            }
            return;
          }
          this.resetSingleItem(cartItem, forceResetToOriginal);
        });
      }
      this.usedPromotions = [];
    },

    // 重置特价商品为特价状态
    resetSpecialPriceItem(cartItem) {
      // 重置促销状态标识
      cartItem.isDiscounted = false;
      cartItem.isRuleApplied = false;
      cartItem.discountInfo = '';
      cartItem.isMergedItem = false;

      // 恢复特价价格
      if (cartItem.spPrice !== undefined || cartItem.spMemberPrice !== undefined) {
        // 重新计算最优价格（考虑限购数量）
        cartItem.actualPrice = this.getOptimalPrice(cartItem, cartItem.quantity);

        // 如果没有手动修改过价格，则更新显示价格
        if (!cartItem.isPriceManuallyChanged) {
          cartItem.changePrice = cartItem.actualPrice;
        }
        // 计算金额，考虑限购数量
        if (cartItem.isLimitedQuantity && cartItem.quantity > cartItem.limitedQuantity) {
          // 如果超出可优惠数量，分别计算优惠部分和超出部分的金额
          const limitedPartAmount = cartItem.limitedQuantity * cartItem.changePrice;
          const extraPartAmount = (cartItem.quantity - cartItem.limitedQuantity) * cartItem.extraPrice;
          cartItem.amount = limitedPartAmount + extraPartAmount;
        } else {
          // 未超出限购数量，正常计算金额
          cartItem.amount = cartItem.changePrice * cartItem.quantity;
          // 清除限购信息
          cartItem.limitInfo = '';
        }

        // 如果允许抹零，对金额进行处理（角抹零，四舍五入）
        if (this.memberInfo.isSmall === 1) {
          cartItem.amount = Math.round(cartItem.amount * 10) / 10;
        }else if (this.memberInfo.isSmall === 2) {
          cartItem.amount = Math.floor(cartItem.amount * 10) / 10;
        }
      }
    },
    // 合并同批次商品
    mergeSameBatchItems() {
      console.log("开始合并同批次商品（相同商品ID、批次号、生产日期、失效日期）");
      // 创建批次映射表
      const batchMap = new Map();

      // 遍历购物车商品，按批次分组
      this.cartItems.forEach((item, index) => {
        // 跳过赠品和特价商品
        if (item.isGift || item.isSpecialPrice) {
          return;
        }

        // 生成批次唯一标识：商品ID + 批次号 + 生产日期 + 失效日期
        const batchKey = `${item.bgmId}_${item.batchno || item.batchNo || ''}_${item.prodate || ''}_${item.expidate || ''}`;

        if (!batchMap.has(batchKey)) {
          batchMap.set(batchKey, {
            mainItem: item,
            mainIndex: index,
            totalQuantity: item.quantity || 0,
            duplicateIndexes: []
          });
        } else {
          // 找到重复批次，累加数量
          const batchInfo = batchMap.get(batchKey);
          batchInfo.totalQuantity += (item.quantity || 0);
          batchInfo.duplicateIndexes.push(index);
        }
      });

      // 处理需要合并的批次
      const itemsToRemove = [];

      batchMap.forEach((batchInfo, batchKey) => {
        if (batchInfo.duplicateIndexes.length > 0) {
          console.log(`合并相同批次商品 ${batchKey}，总数量: ${batchInfo.totalQuantity}`);

          // 更新主商品数量
          batchInfo.mainItem.quantity = batchInfo.totalQuantity;

          // 重新计算主商品金额
          batchInfo.mainItem.amount = batchInfo.mainItem.changePrice * batchInfo.totalQuantity;

          // 如果允许抹零，对单个商品金额进行抹零处理
          if (this.memberInfo.isSmall === 1) {
            batchInfo.mainItem.amount = Math.round(batchInfo.mainItem.amount * 10) / 10;
          }else if(this.memberInfo.isSmall === 2){ 
            batchInfo.mainItem.amount = Math.floor(batchInfo.mainItem.amount * 10) / 10;
          }

          // 标记重复项待删除
          batchInfo.duplicateIndexes.forEach(index => {
            itemsToRemove.push(index);
          });
        }
      });

      // 按索引倒序删除重复项（避免索引变化影响）
      itemsToRemove.sort((a, b) => b - a).forEach(index => {
        console.log(`删除重复商品，索引: ${index}`);
        this.cartItems.splice(index, 1);
      });

      // 如果有合并操作，调整选中索引
      if (itemsToRemove.length > 0) {
        // 如果当前选中的商品被删除了，重置选中状态
        if (itemsToRemove.includes(this.selectedItemIndex)) {
          this.selectedItemIndex = -1;
        } else {
          // 调整选中索引（考虑删除的商品数量）
          const deletedBeforeSelected = itemsToRemove.filter(index => index < this.selectedItemIndex).length;
          this.selectedItemIndex -= deletedBeforeSelected;
        }

        console.log(`合并完成，删除了 ${itemsToRemove.length} 个重复商品`);
        this.updateTotal();
      }
    },
    // 重置单个商品的状态
    resetSingleItem(cartItem, forceResetToOriginal = false) {
      console.log("重置单个商品的状态并且所有设定的数据");

      // 清除促销相关标记
      cartItem.isDiscounted = false;
      cartItem.isRuleApplied = false;
      cartItem.isSelected = false; // 取消勾选状态
      cartItem.isMergedItem = false; // 清除合并商品标记
      cartItem.discountInfo = "";
      cartItem.mixedPriceInfo = null; // 清除混合价格信息
      cartItem.mergedItems = null; // 清除合并商品信息

      // 根据会员状态设置价格（后输入会员时也要考虑会员价）
      if (this.memberInfo.memId) {
        // 有会员：设置为会员价
        cartItem.changePrice = cartItem.memberPrice || cartItem.price;
        cartItem.actualPrice = cartItem.changePrice;
        cartItem.amount = Number(
          this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
        );
      } else {
        // 无会员：设置为原价
      }
      // 标记为手动修改价格的商品不重置价格
      if (!cartItem.isPriceManuallyChanged) {
        if (this.memberInfo.memId) {
          cartItem.changePrice = cartItem.memberPrice || cartItem.price;
        } else {
          cartItem.changePrice = cartItem.price;
        }
        cartItem.actualPrice = cartItem.changePrice;
        cartItem.amount = Number(
          this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
        );
      }
    },
    // 重置促销方案到最初始状态（清除会员卡时使用）
    resetPromotionToOriginal() {
      console.log("重置促销方案到最初始状态");
      // 清除购物车上面的积分
      this.cartItems.forEach((cartItem) => {
        cartItem.rePoint = 0;
        cartItem.addPoint = 0;
      });

      // 清除购物车中的赠品（满赠促销产生的商品）
      this.removeGiftItemsFromCart([]); // 传入空数组，清除所有赠品
      // 按批次合并同类商品
      this.mergeSameBatchItems();
      // 清除已选择的促销方案
      this.selectedPromotions = [];

      // 检查是否有任何需要重置的打折商品
      const regularDiscountedItems = this.cartItems.filter(
        (item) =>
          (item.isDiscounted || item.discountInfo || item.isMergedItem) &&
          !item.isSpecialPrice &&
          !item.isGift
      );
      if (regularDiscountedItems.length > 0) {
        this.$message.info(
          "已清除所有促销方案，商品恢复最初始状态，特价商品不受影响"
        );
      }
      this.cartItems.forEach((cartItem) => {
        // 特价商品和赠品跳过
        if (cartItem.isSpecialPrice || cartItem.isGift) {
          if (cartItem.isSpecialPrice) {
            console.log("重置特价商品为特价:", cartItem.name || cartItem.bgmName);
            this.resetSpecialPriceItem(cartItem);
          }
          return;
        }
        // 重置到最初始状态
        this.resetSingleItemToOriginal(cartItem);
      });
      this.usedPromotions = [];
    },
    // 重置单个商品到最初始状态
    resetSingleItemToOriginal(cartItem) {
      // 清除促销相关标记
      cartItem.isDiscounted = false;
      cartItem.isRuleApplied = false;
      cartItem.isSelected = false; // 取消勾选状态
      cartItem.isMergedItem = false; // 清除合并商品标记
      cartItem.discountInfo = "";
      cartItem.mixedPriceInfo = null; // 清除混合价格信息
      cartItem.mergedItems = null; // 清除合并商品信息

      // 按批次合并同类商品
      this.mergeSameBatchItems();
      // 根据商品类型恢复价格
      if (cartItem.isSpecialPrice || cartItem.spMemberPrice || cartItem.spPrice) {
        console.log("重置单个商品到最初始状态:", cartItem);
        // 特价商品：恢复特价价格
        cartItem.changePrice = this.getOptimalPrice(cartItem, cartItem.quantity);
        cartItem.actualPrice = cartItem.changePrice;
        console.log("重置单个商品到最初始状态2:", cartItem);
      } else if (this.memberInfo.memId && cartItem.memberPrice) {
        // 有会员且有会员价：恢复会员价
        cartItem.changePrice = cartItem.memberPrice;
        cartItem.actualPrice = cartItem.memberPrice;
      } else {
        // 普通商品：恢复原价
        cartItem.changePrice = cartItem.price;
        cartItem.actualPrice = cartItem.price;
      }
      cartItem.amount = Number(this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity));

    },
    // 清除购物车中的赠品（根据买赠促销中的赠品bgmId匹配）
    removeGiftItemsFromCart(validPromotions = []) {
      // 记录清除前的商品数量
      const beforeCount = this.cartItems.length;
      console.log("清除前的商品数量:", validPromotions);


      // 获取所有买赠促销中的赠品信息（包含bgmId和对应的planId）
      const validGiftBgmIds = [];
      const validGiftPlanIds = []; // 收集有效的planId
      const validGiftInfo = []; // 收集完整的赠品信息

      validPromotions.forEach(plan => {
        if (plan.sellType === 32 && plan.mzGiftType === 1) { // 买赠促销且是赠品类型
          validGiftPlanIds.push(plan.planId); // 收集有效的planId

          if (plan.giftBgmList && Array.isArray(plan.giftBgmList)) {
            plan.giftBgmList.forEach(gift => {
              validGiftBgmIds.push(gift.bgmId);
              validGiftInfo.push({
                bgmId: gift.bgmId,
                planId: plan.planId
              });
            });
          }
        }
      });
      // 过滤掉无效的赠品
      this.cartItems = this.cartItems.filter((item) => {
        // 判断是否为赠品
        const isGift =
          // 1. 明确标记为赠品的商品（这是最可靠的标记）
          item.isGift === true ||
          // 2. 有赠品促销方案名称的商品
          (item.giftPlanName && item.giftPlanName.length > 0) ||
          // 3. discountInfo 明确表示是赠品且价格为0的商品
          (item.discountInfo?.includes("：赠品") &&
            item.changePrice === 0 &&
            item.actualPrice === 0) ||
          // 4. 从赠品列表添加的商品（通过特殊标记识别）
          item.fromGiftList === true;

        // 如果不是赠品，保留
        if (!isGift) {
          return true;
        }

        // 如果是赠品，需要检查bgmId和planId是否都匹配
        const itemBgmId = item.bgmId;
        const itemPlanId = item.planId || item.giftPlanId; // 赠品可能存储在不同字段中

        // 优先检查planId匹配（如果赠品有planId）
        if (itemPlanId) {
          // 如果赠品有planId，必须在有效的planId列表中
          if (validGiftPlanIds.includes(itemPlanId)) {
            return true;
          } else {
            return false;
          }
        } else {
          // 如果赠品没有planId，则按bgmId匹配（兜底逻辑）
          if (validGiftBgmIds.includes(itemBgmId)) {
            return true;
          } else {
            return false;
          }
        }
      });

      // 记录清除后的商品数量
      const afterCount = this.cartItems.length;
      const removedCount = beforeCount - afterCount;

      if (removedCount > 0) {
        // 重新计算总金额
        this.updateTotal();
      }

      // 同时清空赠品相关的数据
      this.giftList = [];
      this.allGiftList = [];
      this.giftYhqList = [];
      this.allGiftYhqList = [];

      // 重置单选赠品状态，因为赠品已被清除
      this.selectedSingleGift = null;
      this._needAutoSelectGift = false;
    },
    onSplitItemDialogOpened() {

    },
    onSplitItemDialogClose() {
      this.splitItemDialogVisible = false;
    },
    onSplitItemConfirm() {

    },
    // 拆分商品
    splitItem() {
      this.splitItemDialogVisible = true;
    },
    openPriceEditDialog() {
      if (
        this.selectedItemIndex === -1 ||
        !this.cartItems[this.selectedItemIndex]
      ) {
        this.$message.warning("请先选中要修改单价的商品行");
        return;
      }
      this.selectedCartItem = this.cartItems[this.selectedItemIndex];
      // 移除监听器
      if (this.KeyHandler) {
        window.removeEventListener("keydown", this.KeyHandler, true);
      }
      this.priceEditDialogVisible = true;
    },
    openQuantityEditDialog() {
      if (
        this.selectedItemIndex === -1 ||
        !this.cartItems[this.selectedItemIndex]
      ) {
        this.$message.warning("请先选中要修改数量的商品行");
        return;
      }
      this.selectedCartItem = this.cartItems[this.selectedItemIndex];

      // 检查是否为专管或含麻商品
      const isSpecial =
        this.selectedCartItem.bgiType &&
        (this.selectedCartItem.bgiType.includes("含麻") ||
          this.selectedCartItem.bgiType.includes("专管"));

      if (isSpecial) {
        // 计算当前专管/含麻商品的总数量
        const currentSpecialTotal = this.cartItems
          .filter(
            (item) =>
              item.bgiType &&
              (item.bgiType.includes("含麻") || item.bgiType.includes("专管"))
          )
          .reduce((sum, item) => sum + (item.quantity || 0), 0);

        // 计算其他专管/含麻商品的数量（不包括当前商品）
        const otherSpecialTotal =
          currentSpecialTotal - (this.selectedCartItem.quantity || 0);

        // 设置最大数量限制
        const maxQuantity = 2 - otherSpecialTotal;
        if (maxQuantity <= 0) {
          this.$message.warning(
            "专管/含麻类商品总数量已达到2盒上限，无法继续增加"
          );
          return;
        }
      }
      this.quantityEditDialogVisible = true;
    },
    // 打开销售员选择弹窗
    openSalesPersonSelectDialog() {
      if (
        this.selectedItemIndex === -1 ||
        !this.cartItems[this.selectedItemIndex]
      ) {
        this.$message.warning("请先选中要修改销售员的商品行");
        return;
      }
      this.selectedCartItem = this.cartItems[this.selectedItemIndex];
      this.salesPersonSelectDialogVisible = true;
    },
    // 销售员失焦处理
    onSales() {
      this.onSalesPersonBlur(1);
      // 确保下拉框关闭
      if (this.$refs.salesPersonSelect) {
        // 如果有visible属性，设置为false
        if (this.$refs.salesPersonSelect.visible !== undefined) {
          this.$refs.salesPersonSelect.visible = false;
        }
      }
    },
    // 开方医师失焦处理
    onDoctorBlur() {
      // 调用原有的失焦处理
      this.onSalesPersonBlur(2);

      // 确保下拉框关闭
      if (this.$refs.doctorSelect) {
        // 如果有visible属性，设置为false
        if (this.$refs.doctorSelect.visible !== undefined) {
          this.$refs.doctorSelect.visible = false;
        }
      }
    },

    // 辅助项目失焦处理
    onAssistanceInfoBlur() {
      // 调用原有的失焦处理
      this.onSalesPersonBlur(4);

      // 确保下拉框关闭
      if (this.$refs.assistanceInfoSelect) {
        // 如果有visible属性，设置为false
        if (this.$refs.assistanceInfoSelect.visible !== undefined) {
          this.$refs.assistanceInfoSelect.visible = false;
        }
      }
    },
    // 执业药师失焦处理
    onPharmacistBlur() {
      // 调用原有的失焦处理
      this.onSalesPersonBlur(3);

      // 确保下拉框关闭
      if (this.$refs.pharmacistSelect) {
        // 如果有visible属性，设置为false
        if (this.$refs.pharmacistSelect.visible !== undefined) {
          this.$refs.pharmacistSelect.visible = false;
        }
      }
    },
    // 移除购物车商品
    removeItem(index) {
      const removedItem = this.cartItems[index];
      this.cartItems.splice(index, 1);

      // 如果被移除的是促销方案商品，则移除相关赠品
      if (removedItem && !removedItem.isGift) {
        // 查找所有包含该商品的促销方案
        const relatedPromotions = this.selectedPromotions.filter(
          (plan) =>
            Array.isArray(plan.bgmIdList) &&
            plan.bgmIdList.includes(removedItem.bgmId)
        );
        relatedPromotions.forEach((plan) => {
          // 找到该方案下所有赠品bgmId
          let giftBgmIds = [];
          if (Array.isArray(plan.stageList)) {
            plan.stageList.forEach((stage) => {
              if (Array.isArray(stage.contentList)) {
                stage.contentList.forEach((gift) => {
                  giftBgmIds.push(gift.bgmId);
                });
              }
            });
          }
          // 移除购物车中属于该方案的所有赠品
          this.cartItems = this.cartItems.filter(
            (item) => !(item.isGift && giftBgmIds.includes(item.bgmId))
          );
        });
      }

      // 新增：删除对应的积分倍数记录
      if (removedItem) {
        const recordIndex = this.pointMultiplyItems.findIndex(
          (item) =>
            item.bgmId === removedItem.bgmId &&
            item.batchno === removedItem.batchno
        );

        if (recordIndex !== -1) {
          this.pointMultiplyItems.splice(recordIndex, 1);
          console.log("已删除积分倍数记录，剩余记录:", this.pointMultiplyItems);
        }
      }

      // 如果删除的是当前选中的商品，重置选中状态
      if (index === this.selectedItemIndex) {
        this.selectedItemIndex = -1;
        this.quantityChange = 0;
        this.selectedProduct = {};
      } else if (index < this.selectedItemIndex) {
        // 如果删除的商品在当前选中商品之前，调整选中索引
        this.selectedItemIndex--;
      }
      this.getRealTimePromotions();
      this.updateTotal();
    },
    //  汇总明细查询弹窗 收银台获取的10单 
    // 打开汇总明细查询弹窗
    openSummaryDetailDialog() {
      // 设置查询参数
      this.summaryQueryParams = {
        storeId: this.storeId,
        deskId: this.memberInfo.deskId,
        skPrint: this.skPrint
        // startDate: this.curDate,
        // endDate: this.curDate
      };

      // 显示弹窗
      this.summaryDetailDialogVisible = true;
    },

    // 汇总明细弹窗打开事件
    onSummaryDetailDialogOpened() {
      console.log('汇总明细查询弹窗已打开');
    },

    // 汇总明细弹窗关闭事件
    onSummaryDetailDialogClose() {
      this.summaryDetailDialogVisible = false;
      console.log('汇总明细查询弹窗已关闭');

      // 关闭后聚焦到商品录入输入框
      this.$nextTick(() => {
        this.focusProductSearchInput();
      });
    },

    // 条码维护相关方法
    // 打开条码维护弹窗
    openBarcodeMaintenanceDialog() {
      // 显示条码维护弹窗
      this.barcodeMaintenanceDialogVisible = true;
    },

    // 条码维护弹窗打开事件
    onBarcodeMaintenanceDialogOpened() {
      console.log('条码维护弹窗已打开');
    },

    // 条码维护弹窗关闭事件
    onBarcodeMaintenanceDialogClose() {
      this.barcodeMaintenanceDialogVisible = false;
      console.log('条码维护弹窗已关闭');

      // 关闭后聚焦到购物车表格
      this.$nextTick(() => {
        this.focusCartTable();
      });
    },

    // 条码维护确认事件
    onBarcodeMaintenanceConfirm(data) {
      console.log('条码维护确认:', data);

      // 更新购物车中对应商品的条码信息
      if (data.cartItem && data.barcode) {
        const cartItem = this.cartItems.find(item =>
          item.bgmId === data.cartItem.bgmId &&
          item.bgmCode === data.cartItem.bgmCode
        );

        if (cartItem) {
          // 更新条码
          cartItem.barcode = data.barcode;

          this.$message.success(`商品 ${cartItem.bgmName} 的条码已更新为 ${data.barcode}`);
        }
      }

      // 重新计算总价等信息
      this.updateTotal();
    },
    // 检查是否有商品有效期小于30天，拦截提示
    async checkExpireDate() {
      var days = 30
      try {
        const res = await this.$http.fromrulequeryByIdToJson({ ids: [18001] });

        // 尝试从响应中获取自定义天数设置
        if (res.status == 200 && res.result && res.result.ruleParam.expLimitDays) {
          days = res.result.ruleParam.expLimitDays.value || 0;
        }
      } catch (error) {
        console.warn('获取有效期限制天数失败，使用默认值30天', error);
      }
      // 如果没有设置有效期限制，则不进行检查
      if (days <= 0) {
        return false;
      }
      // 检查购物车中的商品是否即将过期
      const today = new Date();
      const limitDate = today.getTime() + Number(days) * 24 * 60 * 60 * 1000

      for (const item of this.cartItems) {
        // 检查商品是否有有效期且不为空字符串
        if (item.expidate && item.expidate !== "") {
          const expireDate = item.expidate;
          // 如果商品在限定日期前过期，则提示警告
          if (expireDate < limitDate) {
            this.$message.warning(`商品 ${item.bgmName} 的有效期小于${days}天，请注意！`);
            return true;
          }
        }
      }

      return false;
    }

  },
};
